import { createAction, props } from '@ngrx/store';

export const updateEndorsementsIsLoadingFromEndorsementsSavingData = createAction(
  '[EndorsementsavingData] Update Endorsements Is Loading',
  props<{ isLoading: boolean }>()
);